module.exports = __webpack_public_path__ + "static/img/banner_03.40ae7e7c.png";